const csvTemplate = `activity_type,user,address_id,date,time_from,time_to,notes
visit_existing_customer,salesman.email@sociolla.com,621142cb479b0b7e84f8b9b8,17-03-2026,09:00,10:00,Visit customer
invoice_collecton,salesman.email@sociolla.com,621142cb479b0b7e84f8b9b8,17-03-2026,13:00,14:00,Collect invoice`;

export default csvTemplate;
